import { Collection } from './Collection';
import { JobModel } from './JobModel';

export class JobCollection extends Collection {
  constructor(data) {
    super(data, JobModel);
  }
}
